import $ from 'jquery';
import Sheet from '../modules/ui-sheet';

function initializeUISheet() {
  const $contactFormUISheet = $('.js-contact-form-ui-sheet');
  const $contestFormUISheet = $('.js-contest-form-ui-sheet');

  if ($contactFormUISheet.length) {
    new Sheet($contactFormUISheet, {
      $contentNodes: [$('.js-expandable-questions'), $('.js-contact-form-wrapper')],
      tabletDown: true,
    });
  }

  if ($contestFormUISheet.length) {
    new Sheet($contestFormUISheet, {
      $contentNodes: [$('.js-contact-form-wrapper')],
      tabletDown: true,
    });
  }
}

export default initializeUISheet;
